import {NgModule} from '@angular/core'
import {CraftsmenRegionPageComponent} from './region-page/craftsmen-region-page.component'
import {AsyncPipe} from '@angular/common'
import {HeroCoverModule} from '../../../shared/components/hero-cover/hero-cover.module'
import {CraftsmenRegionDirectoryRoutingModule} from './craftsmen-region-directory-routing.module'
import {KnowledgeSectionComponent} from '../../../shared/components/content/knowledge-section/knowledge-section.component'
import {PresentationSectionComponent} from '../../../shared/components/presentation-section/presentation-section.component'
import {ProDirectoryByOfferingSectionComponent} from '../../../shared/components/pro-directory-by-offering-section/pro-directory-by-offering-section.component'
import {ProDirectoryByRegionSectionComponent} from '../../../shared/components/pro-directory-by-region-section/pro-directory-by-region-section.component'
import {StickyBottomNavigationModule} from '../../../shared/components/sticky-bottom-navigation/sticky-bottom-navigation.module'
import {TranslocoDirective} from '@ngneat/transloco'
import {ChipComponent} from '../../../craft/chip/chip.component'
import {ReplacePropsPipe} from '../../../shared/pipes/replace-props.pipe'
import {IndustryRegionPageComponent} from './industry-region-page/industry-region-page.component'
import {BreadcrumbsModule} from '../../../craft/breadcrumbs/breadcrumbs.module'
import {HeroSellingPointComponent} from '../../../shared/components/hero-cover/hero-selling-point/hero-selling-point.component'
import {RegionDirectoryPageComponent} from './region-directory-page/region-directory-page.component'
import {ArticlePreviewComponent} from '../article/article-preview/article-preview.component'
import {ButtonModule} from '../../../craft/button/button.module'
import {FilterModule} from '../../../craft/filter/filter.module'
import {HolyGrailGridModule} from '../../../craft/holy-grail-grid/holy-grail-grid.module'
import {SearchbarComponent} from '../../../craft/searchbar/searchbar.component'
import {SpinnerComponent} from '../../../craft/spinner/spinner.component'
import ProDirectoryPageModule from '../pro-directory-page/pro-directory-page.module'
import {IndustriesAndRegionsComponent} from './region-directory-page/industries-and-regions/industries-and-regions.component'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {ListElementComponent} from '../../../craft/list-element/list-element.component'
import {IndustriesAndRegionsSkeletonComponent} from './region-directory-page/industries-and-regions/industries-and-regions-skeleton.component'
import {RegionDirectorySidenavDirectLinksComponent} from './region-directory-page/region-directory-sidenav-direct-links/region-directory-sidenav-direct-links.component'
import {RegionDirectorySidenavIndustriesComponent} from './region-directory-page/region-directory-sidenav-industries/region-directory-sidenav-industries.component'
import {SupportSectionComponent} from '../../../shared/components/content/support-section/support-section.component'
import {ReviewsSectionComponent} from '../../../shared/components/content/reviews-section/reviews-section.component'
import {InspirationSectionComponent} from '../../../shared/components/content/inspiration-section/inspiration-section.component'
import {PromotionalBannerSectionComponent} from '../../../shared/components/content/promotional-banner-section/promotional-banner-section.component'
import {ContentSectionComponent} from '../../../craft/content-section/content-section.component'
import {RichTextModule} from '../../../shared/components/rich-text/rich-text.module'
import {LeadSignupSectionComponent} from '../../../shared/components/content/lead-signup-section/lead-signup-section.component'
import {LeadSignupBannerComponent} from '../../../shared/components/content/lead-signup-section/lead-signup-banner.component'
import {RegionalDirectoryCssIdPipe} from './craftsmen-region-directory-css-id.pipe'
import {HolyGrailStickyWrapperComponent} from '../../../craft/holy-grail-grid/holy-grail-grid-col-left/holy-grail-sticky-wrapper.component'
import {ProMapComponent} from '../../../shared/components/pro-map/pro-map.component'
import {PaginationComponent} from '../../../craft/pagination/pagination.component'
import {RelatedItemsSectionComponent} from '../../../shared/components/content/related-items-section/related-items-section.component'
import {MapRelatedRegionsPipe} from './region-page/map-related-regions.pipe'
import {MapRelatedRegionsAndIndustryPipe} from './industry-region-page/map-related-regions-and-industry.pipe'
import {MapRelatedIndustriesPipe} from './industry-region-page/map-related-industires.pipe'
import {RelatedArticlesSectionComponent} from '../../../shared/components/content/related-articles-section/related-articles-section.component'
import {VideoSectionComponent} from '../../../shared/components/content/video-section/video-section.component'

@NgModule({
  imports: [
    CraftsmenRegionDirectoryRoutingModule,
    AsyncPipe,
    HeroCoverModule,
    HeroSellingPointComponent,
    KnowledgeSectionComponent,
    PresentationSectionComponent,
    ProDirectoryByOfferingSectionComponent,
    ProDirectoryByRegionSectionComponent,
    BreadcrumbsModule,
    StickyBottomNavigationModule,
    TranslocoDirective,
    ChipComponent,
    ReplacePropsPipe,
    BreadcrumbsModule,
    ArticlePreviewComponent,
    ButtonModule,
    FilterModule,
    HolyGrailGridModule,
    SearchbarComponent,
    SpinnerComponent,
    ProDirectoryPageModule,
    FaIconComponent,
    ListElementComponent,
    SupportSectionComponent,
    ReviewsSectionComponent,
    InspirationSectionComponent,
    PromotionalBannerSectionComponent,
    ContentSectionComponent,
    RichTextModule,
    LeadSignupSectionComponent,
    LeadSignupBannerComponent,
    RegionalDirectoryCssIdPipe,
    HolyGrailStickyWrapperComponent,
    ProMapComponent,
    PaginationComponent,
    RelatedItemsSectionComponent,
    MapRelatedRegionsAndIndustryPipe,
    MapRelatedIndustriesPipe,
    MapRelatedRegionsPipe,
    RelatedArticlesSectionComponent,
    VideoSectionComponent,
  ],
  declarations: [
    CraftsmenRegionPageComponent,
    IndustryRegionPageComponent,
    RegionDirectoryPageComponent,
    IndustriesAndRegionsComponent,
    IndustriesAndRegionsSkeletonComponent,
    RegionDirectorySidenavIndustriesComponent,
    RegionDirectorySidenavDirectLinksComponent,
  ],
})
export default class CraftsmenRegionDirectoryModule {}
